import { API as e, Resource as t } from "@coveo/platform-client";
// src/resources/SchemaServiceTemporaryResource.ts
var n = class n extends t {
	static {
		this.getBaseUrl = () => `/rest/organizations/${e.orgPlaceholder}/schema/sources`;
	}
	validateSlackToken(e) {
		let t = "";
		return Object.keys(e).forEach((n) => t += `${n}=${e[n]}&`), this.api.post(`${n.getBaseUrl()}/SLACK/validateToken?${t.slice(0, -1)}`);
	}
};
export { n as SchemaServiceTemporaryResource };

//# sourceMappingURL=SchemaServiceTemporaryResource.js.map